var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1638501267344,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5507,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.928 144.32h975.168v48.832H20.928v-48.832z m0 95.36h975.168v53.568H20.928v-53.568z m0 102.4h975.168v53.568H20.928v-53.568z m0 97.792h975.168v53.504H20.928v-53.504z m0 100.032h975.168v51.2H20.928v-51.2z m0 97.792h975.168v51.2H20.928v-51.2z m0 107.008h975.168v51.2H20.928v-51.2z",
    fill: "#C14534",
    "p-id": 5508
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.928 144.32H512v395.584H20.928z",
    fill: "#00467B",
    "p-id": 5509
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M342.08 246.72l9.344 60.48 34.88-51.2-18.56 60.48 53.504-32.576-41.92 46.592 62.848-4.672L384 346.752l58.24 23.296-62.912-4.672 41.92 44.224-53.568-30.272 18.624 58.24-34.88-51.2-9.344 62.784-6.976-62.848-34.88 51.2 18.56-58.176-53.504 30.272 41.92-44.16-62.848 4.608 58.24-23.296-58.24-20.928 62.848 4.672-41.92-46.592 53.568 32.64L300.16 256l34.88 51.2z",
    fill: "#E8C52B",
    "p-id": 5510
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M244.352 460.8c-62.848 0-114.048-51.2-114.048-114.048s51.2-111.68 114.048-111.68c18.624 0 37.248 4.608 53.568 13.952-23.296-18.624-51.2-30.272-81.472-30.272-69.824 0-128 58.24-128 128 0 69.824 58.176 128 128 128a125.44 125.44 0 0 0 81.472-30.272c-14.016 9.344-32.64 16.32-53.568 16.32z",
    fill: "#E8C52B",
    "p-id": 5511
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.8e764bf4.svg";
export { ForwardRef as ReactComponent };